import type { OtkPermission } from "@/lib/api/users"

// subject-roles.md RO1's permission-matrix row order and labels — mirrors
// auth-utils.ts's `Permissions` array order verbatim. `GET /roles`
// only returns booleans keyed by these names, not display labels, so the
// labels are owned client-side, same as the prototype's `lib/permissions.ts`.
export const permissionOrder: OtkPermission[] = [
  "viewAssignedPunkty",
  "manageDrafts",
  "manageUsersRolesInvites",
  "allPunktyStats",
  "edrtzKepServices",
  "signAndSendEdrtz",
  "manageWarehouseDistribution",
  "manageSchedule",
  "viewPayments",
  "managePayments",
  "viewAudit",
]

export const permissionLabels: Record<OtkPermission, string> = {
  viewAssignedPunkty: "Перегляд даних призначених пунктів",
  manageDrafts: "Створення/редагування чернеток документів ОТК",
  manageUsersRolesInvites: "Керування користувачами, запрошеннями та ролями",
  allPunktyStats: "Статистика по всіх пунктах суб'єкта",
  edrtzKepServices: "Сервіси ЄДРТЗ, що потребують КЕП",
  signAndSendEdrtz: "Підпис і надсилання до ЄДРТЗ",
  manageWarehouseDistribution: "Розподіл спецпродукції між пунктами ОТК",
  manageSchedule: "Запис клієнтів у розкладі пункту ОТК",
  viewPayments: "Перегляд розділу «Оплати»",
  managePayments: "Проведення оплат суб'єкта ОТК",
  viewAudit: "Перегляд журналу дій користувачів",
}
